export const PENDING_INPUT_STORAGE_KEY = "unfold:pending_input";

/** Query flag the processing screen adds when sending the user back after a failed unfolding. */
export const UNFOLD_FAILED_PARAM = "unfold_failed";

export type PendingInput = {
  value: string;
  type: "link" | "text";
};

export function readPendingInput(): PendingInput | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem(PENDING_INPUT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<PendingInput>;
    if (
      typeof parsed.value === "string" &&
      parsed.value.trim() &&
      (parsed.type === "link" || parsed.type === "text")
    ) {
      return { value: parsed.value, type: parsed.type };
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function clearPendingInput(): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(PENDING_INPUT_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function writePendingInput(input: PendingInput): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(PENDING_INPUT_STORAGE_KEY, JSON.stringify(input));
  } catch {
    /* ignore */
  }
}
